import { motion } from "framer-motion";
import DynIcon from "@/components/DynIcon";
import { Reveal, Stagger, staggerItem } from "@/components/Reveal";
import { FEATURES } from "@/lib/site";

const ACCENTS = [
  { tile: "bg-cyan-500/10 border-cyan-500/20 text-cyan-400", glow: "bg-cyan-500/10", hover: "hover:border-cyan-500/50" },
  { tile: "bg-violet-500/10 border-violet-500/20 text-violet-300", glow: "bg-violet-500/10", hover: "hover:border-violet-500/50" },
  { tile: "bg-pink-500/10 border-pink-500/20 text-pink-300", glow: "bg-pink-500/10", hover: "hover:border-pink-500/50" },
  { tile: "bg-sky-500/10 border-sky-500/20 text-sky-300", glow: "bg-sky-500/10", hover: "hover:border-sky-500/50" },
  { tile: "bg-fuchsia-500/10 border-fuchsia-500/20 text-fuchsia-300", glow: "bg-fuchsia-500/10", hover: "hover:border-fuchsia-500/50" },
  { tile: "bg-blue-500/10 border-blue-500/20 text-blue-300", glow: "bg-blue-500/10", hover: "hover:border-blue-500/50" },
];

export default function Features() {
  return (
    <section className="relative py-24 sm:py-32 bg-ink-950" data-testid="features-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-3xl mb-16">
          <p className="overline mb-4">Why CYAN</p>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-white leading-[0.95]">
            Everything you want.<br />None of the games.
          </h2>
          <p className="mt-6 text-lg text-zinc-400 max-w-2xl">
            We built CYAN around a simple idea: internet should be fast, honest and human. Here's what that looks like.
          </p>
        </Reveal>

        <Stagger className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((f, i) => {
            const a = ACCENTS[i % ACCENTS.length];
            return (
              <motion.div
                key={f.title}
                variants={staggerItem}
                className={`group relative bg-ink-900 border border-white/5 rounded-2xl p-8 overflow-hidden transition-colors ${a.hover}`}
              >
                <div className={`absolute -top-16 -right-16 w-40 h-40 rounded-full ${a.glow} blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500`} />
                <div className="relative">
                  <div className={`w-12 h-12 grid place-items-center rounded-xl border ${a.tile} mb-6 group-hover:scale-110 transition-transform`}>
                    <DynIcon name={f.icon} size={22} />
                  </div>
                  <h3 className="font-display font-bold text-xl text-white mb-2">{f.title}</h3>
                  <p className="text-zinc-400 text-[15px] leading-relaxed">{f.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </Stagger>
      </div>
    </section>
  );
}
